import { AlertCircle } from "lucide-react";

interface AfterHoursBannerProps {
  onDismiss: () => void;
  onDismissPermanently: () => void;
}

export function AfterHoursBanner({
  onDismiss,
  onDismissPermanently,
}: AfterHoursBannerProps) {
  return (
    <div className="flex gap-4 rounded-xl border border-utility-warning-500 bg-white p-4 shadow-sm">
      <div className="mt-0.5 shrink-0">
        <AlertCircle className="text-utility-warning-500" size={20} />
      </div>
      <div className="flex flex-1 flex-col gap-1">
        <span className="text-sm font-semibold text-utility-gray-700">
          We&apos;re offline right now
        </span>
        <span className="text-sm text-utility-gray-600">
          Hey! Just a heads-up, our team is currently offline. We&apos;ll get
          back to you during business hours (Mon&ndash;Fri, 8AM&ndash;4PM ET).
          Thanks for your patience!
        </span>
        <div className="mt-2 flex gap-3">
          <button
            className="cursor-pointer text-sm font-semibold text-utility-gray-600 hover:underline"
            onClick={onDismissPermanently}
            type="button"
          >
            Don&apos;t show again
          </button>
          <button
            className="cursor-pointer text-sm font-semibold text-utility-brand-700 hover:underline"
            onClick={onDismiss}
            type="button"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
